<div>
  <div class="row mainLine">
    <div class="col historyLine">
      <div style="border: 0.25rem solid #000; text-align: center; padding: 0.5rem">
        <h4>N° Tentatives: {{ job?.nbTentative }}</h4>
      </div>

      <div class="card-container mt-4">
        <div *ngFor="let item of AllHistory">
          <div class="history-card" *ngIf="item.status != 2024">
            <div class="card-header">
              <span class="date-span">
                {{ item.date | date : "dd/MM/yy HH:mm" }}
              </span>
            </div>
            <div class="display">
              <div class="card-body-status">
                <app-jobs-badge-status [status]="item.status" [item]="item.jobRequest" [jrh]="item"
                  [failureReason]="item.failureReason" [reportedTo]="item.reportedTo" [withBorder]="false">
                </app-jobs-badge-status>
              </div>
              <!--             <div class="vertical-divider"></div>
 -->
              <div class="display-driver">
                <div *ngIf="
                  item.status == 6 ||
                  item.status == 16 ||
                  item.status == 31 ||
                  item.status == 28 ||
                  item.status == 29
                ">
                  {{ item?.centrale?.name }}
                </div>
                <div *ngIf="item.status == 'A1'">

                  <div *ngIf="item.callTo && item.driverIsTheCaller">
                    chauffeur >> {{ item?.callTo}}({{item?.duration}}s)
                  </div>
                  <div *ngIf="item.callTo && !item.driverIsTheCaller">
                    {{ item?.callTo}} >> chauffeur ({{item?.duration}}s)
                  </div>
                </div>
                <div *ngIf="item.oldSize">
                  <!-- Size update detection based on oldSize presence -->
                  <div *ngIf="item.editedByPartner">
                    {{ item?.business?.nomCommercial }}
                  </div>
                  <div *ngIf="item.editedByAdmin && item?.actionDoneBy?.name">
                    Par Admin: {{ item?.actionDoneBy?.name }}
                  </div>
                  <div class="mt-2">
                    <p class="font-weight-bold mb-2">Taille modifiée:</p>
                    <div class="d-flex align-items-center">
                      <span class="badge badge-info p-2">{{ getSizeLabel(item.oldSize) }}</span>
                      <span class="mx-3">→</span>
                      <span class="badge badge-success p-2">{{ getSizeLabel(job?.packageSize || 1) }}</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.status == 32 && item?.destinationCentral?.name">
                  vers {{ item?.destinationCentral?.name }}
                </div>

                <!--  <p>
              {{ item?.jobRequest?.service == 1 ? "Conciergerie" : "" }}
              <span *ngIf="item?.jobRequest?.service == 2" class="font-weight-bold text-uppercase">
                {{ (item.type ? 'Action' : (item.jobRequest?.pickUpJob ? 'Livraison' : 'Pickup')) }}
              </span>
            </p> -->

                <p *ngIf="!item.isReturningToClient && item.driver">
                  {{ "CONCIERGERIE.DRIVER" | translate }} :
                  {{ item?.driver?.name }}
                </p>
                <p *ngIf="item.comment">
                  {{ item?.comment }}
                </p>

                <div *ngIf="item?.link">
                  <audio class="audioPlayer" controls src="{{ item?.link }}">
                    Your browser does not support the <code>audio</code> element.
                  </audio>
                  <div class="share-container">
                    <span>Partager: </span>
                    <label class="switch s-info">
                      <input type="checkbox" [(ngModel)]="item.visibleToPartner"
                        (change)="changeVisibility(item, item.link, $event)" />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>

                <p *ngIf="item.isReturningToClient" class="text-danger">
                  {{ "LIVRAISON.RETURNING_SHIPMENT" | translate }}
                </p>

                <p *ngIf="item.isSwitchingDriver">
                  {{ "GENERAL.OLD" | translate }}
                  {{ "CONCIERGERIE.DRIVER" | translate }} :
                  {{ item?.oldDriver?.name }}
                  <br />
                  {{ "GENERAL.NEW" | translate }}
                  {{ "CONCIERGERIE.DRIVER" | translate }} :
                  {{ item?.newDriver?.name }}
                </p>
                <p *ngIf="item?.actionDoneBy?.name">
                  {{ item?.actionDoneBy?.name }}
                </p>
                <p *ngIf="item?.oldFinalCLientPhone">
                  Ancien téléphone: {{ item?.oldFinalCLientPhone }}
                </p>
                <p *ngIf="item?.oldCity">
                  Ancienne Gouvernorat: <b>{{ item?.oldCity }}</b>
                </p>
                <p *ngIf="item?.oldSubDivision">
                  Ancienne Ville: <b>{{ item?.oldSubDivision }}</b>
                </p>
                <p *ngIf="item?.oldAddress">
                  Ancienne Adresse: <b>{{ item?.oldAddress }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Display creation date card -->
        <div class="history-card">
          <div class="card-header">
            <span class="date-span">
              {{
              AllHistory[AllHistory.length - 1]?.jobRequest.createdAt
              | date : "dd/MM/yy"
              }}
            </span>
          </div>
          <div class="card-body">
            <span class="text-info">Date de création</span>
            <p class="font-weight-bold text-uppercase">Nouveau</p>
            <p>colis créé par le partenaire</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md col-12 actionLine" [ngClass]="{ 'col-12': router.url.includes('fromMap') }">
      <div style="border: 0.25rem solid #000; text-align: center; padding: 0.5rem">
        <h4>Support</h4>
      </div>

      <div class="ticket-container mt-4">
        <div *ngFor="let supportItem of supportHistory" class="ticket">
          <h4>{{ supportItem.type }}</h4>
          <p>{{ supportItem.text }}</p>
          <div class="ticket-info">
            <span *ngIf="supportItem.status === 0" class="badge badge-secondary">Envoyé</span>
            <span *ngIf="supportItem.status === 1" class="badge badge-primary">Nouveau</span>
            <span *ngIf="supportItem.status === 2" class="badge badge-warning">En cours de traitement</span>
            <span *ngIf="supportItem.status === 3" class="badge badge-success">Fermé</span>
            <span>Date: {{ supportItem.date | date : "dd/MM/yy HH:mm " }}</span>
          </div>
        </div>

        <div *ngIf="!supportHistory.length" class="ticket">
          <h4>Pas de données</h4>
        </div>
      </div>
    </div>
  </div>
</div>